import { render, staticRenderFns } from "./OrdersFBAShow.vue?vue&type=template&id=7bea0e9e"
import script from "./OrdersFBAShow.vue?vue&type=script&lang=js"
export * from "./OrdersFBAShow.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBAShow.vue?vue&type=style&index=0&id=7bea0e9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports